import { colorsPalettes } from "@similarweb/styles";
import type { IButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import type * as React from "react";
import { useState } from "react";
import styled from "styled-components";

interface IFaviconButtonProps {
    isCurrentItemFavorite?: boolean;
    onFavoriteClick: () => void;
    hoverMessages?: any;
}

const FavIconButton = styled(IconButton)`
    #star-full,
    .SWReactIcons svg {
        height: 100%;
        width: 100%;
    }
    #star-full,
    .SWReactIcons svg path {
        fill: ${({ isDisabled }: IButtonProps) => (!isDisabled ? `${colorsPalettes.blue[400]}` : null)};
    }

    .SWReactIcons {
        padding-bottom: 3px;
    }

    &:hover {
        #star-full,
        .SWReactIcons svg path {
            fill: ${({ isDisabled }: IButtonProps) => (!isDisabled ? `${colorsPalettes.blue[500]}` : null)};
        }
    }
`;
const StarButtonStyle = styled.div``;

export const FaviconButton: React.FC<IFaviconButtonProps> = ({
    isCurrentItemFavorite,
    hoverMessages,
    onFavoriteClick,
}) => {
    const [isLocked, setLocked] = useState(false);

    const toggleLocked = (value) => {
        setLocked(value);
    };

    const onClick = () => {
        if (isLocked) {
            return;
        }
        toggleLocked(true);
        onFavoriteClick();
        setTimeout(() => {
            toggleLocked(false);
        }, 2000);
    };

    const getHoverContent = () => {
        const { hoverTitleFavoriteAdd, hoverTitleFavoriteRemove } = hoverMessages;
        return (
            <>
                {!isCurrentItemFavorite && <I18n>{hoverTitleFavoriteAdd}</I18n>}
                {isCurrentItemFavorite && <I18n>{hoverTitleFavoriteRemove}</I18n>}
            </>
        );
    };

    const { labelFavoriteAdd, labelFavoriteRemove } = hoverMessages;

    return (
        <PlainTooltip
            cssClass="plainTooltip-element PlainTooltip--favoritesStar favorites"
            text={getHoverContent()}
            closePopupOnClick={!isLocked}
            placement="bottom"
        >
            <StarButtonStyle>
                {isCurrentItemFavorite ? (
                    <FavIconButton
                        iconName="star-full"
                        type="flat"
                        onClick={onClick}
                        isDisabled={isLocked}
                    >
                        <I18n>{labelFavoriteRemove}</I18n>
                    </FavIconButton>
                ) : (
                    <FavIconButton
                        iconName="star-outline"
                        type="flat"
                        onClick={onClick}
                        isDisabled={isLocked}
                    >
                        <I18n>{labelFavoriteAdd}</I18n>
                    </FavIconButton>
                )}
            </StarButtonStyle>
        </PlainTooltip>
    );
};
